/* eslint-disable no-unused-vars */
import { XhrError } from '../../../remote/request.js';
import { getOptionsFromDataset } from '../../../util/dom.js';

/**
 * Apple pay events
 *
 * @this {HTMLElement}
 * @param {JQuery.TriggeredEvent} e
 */
// @ts-ignore
const applePayHandler = async function(e) {

	e.preventDefault();

	const cart_source = 'applepay';
	const $trigger = $(this);
	const targetIsForm = $trigger.is('form');
	let $submitButton;
	let $paymentForm;
	let payOptions;
	let isProductPayment = false;
	const extraOptions = $trigger.data() || {};

	const { cart } = mpro.shop;

	// Save order XHR, and return payment data
	const saveOrderPayment = function() {
		const form_values = new FormData($paymentForm[0]);
		form_values.append('form_name', $paymentForm.prop('name'));

		return fetch(mpro.config.routes.checkout_order, {
			method: 'POST',
			body: form_values,
			'headers': {
				'X-Requested-With': 'XMLHttpRequest',
			},
		});
	};

	const handleSessionError = function (message) {

		try {
			if (session) {
				if (window.ApplePaySession) {
					// @ts-ignore
					session.completePayment(ApplePaySession.STATUS_FAILURE);
				}
				// Abort session
				session.abort();
			}
		}
		catch (error) {
			console.warn(error);
		}

		// Show error message
		mpro.toast('error', message);
		// Re-enable the submit button
		mpro.removeButtonLoading($submitButton);
	};

	// Process payment using external processor
	const processPayment = function(apple_payment, payment_data) {

		const { payment_code, success_url } = payment_data;

		// Process the payment here
		fetch(payOptions.endpoint, {
			method: 'POST',
			body: JSON.stringify({
				'payment_code': payment_code,
				'apple_payment': apple_payment,
			}),
			headers: {
				'Content-Type': 'application/json',
			},
		})
			.then(response => response.json())
			.then((data) => {
				if (data.success) {
					// @ts-ignore
					// Set apple success
					session.completePayment(ApplePaySession.STATUS_SUCCESS);
					// Redirect to after-checkout
					mpro.setLocation(success_url);
				}
				else {
					handleSessionError(mpro.langvar('error_pay_processing'));
				}
			})
			.catch((error) => {
				console.warn('Error processing payment:', error);
				handleSessionError(mpro.langvar('error_pay_processing'));
			});
	};

	const initProductCart = async function() {
		let itemDataArray;

		if ('cartBuyForm' in extraOptions) {
			// Select form by id of current form
			const $form = extraOptions.cartAddForm && (typeof extraOptions.cartAddForm === 'string') ? $(extraOptions.cartAddForm) : $trigger.closest('form');

			if ($form.length === 0) {
				console.warn('Could not find form target for \'cart-buy\' action', extraOptions.cartAddForm);
				throw new Error(mpro.langvar('unknown_error'));
			}

			// sendData = beforeAddToCart($form.serializeArray());
			itemDataArray = $form.serializeArray();
		}
		// Send only data provided in the link/button (item data cannot be mixed with form-data)
		else {

			itemDataArray = [];
			const cartData = $trigger.data('cart-buy');

			for (const key in cartData) {
				if (cartData.hasOwn(key)) {
					itemDataArray.push({
						name: 'items[product][0][' + key + ']',
						value: cartData[key],
					});
				}
			}

			// Items must be array
			if (itemDataArray.length === 0) {
				throw new Error(mpro.langvar('unknown_error'));
			}
		}

		itemDataArray.push({
			name: 'cart_source',
			value: cart_source,
		});

		await cart.add($.param(itemDataArray));
	};

	// Handle product payment from button
	const finishProductPayment = function(apple_payment) {

		const formDataArray = [];
		const { billingContact, shippingContact } = apple_payment;

		// We have billing contact from apple
		if (billingContact) {
			const billingData = [
				{ name: 'customer[billing_name]', value: `${billingContact.givenName} ${billingContact.familyName}` },
				{ name: 'customer[billing_country_code]', value: billingContact.countryCode },
				{ name: 'customer[billing_state]', value: billingContact.administrativeArea },
				{ name: 'customer[billing_city]', value: billingContact.locality },
				{ name: 'customer[billing_address]', value: billingContact.addressLines.join(', ') },
				{ name: 'customer[billing_postal_code]', value: billingContact.postalCode },
			];

			formDataArray.push(...billingData);
		}
		// We have billing contact from apple
		if (shippingContact) {

			const shippingData = [
				{ name: 'customer[shipping_as_billing]', value: false },
				{ name: 'customer[shipping_name]', value: `${shippingContact.givenName} ${shippingContact.familyName}` },
				{ name: 'customer[shipping_phone]', value: shippingContact.phoneNumber },
				{ name: 'customer[shipping_country_code]', value: shippingContact.countryCode },
				{ name: 'customer[shipping_state]', value: shippingContact.administrativeArea },
				{ name: 'customer[shipping_city]', value: shippingContact.locality },
				{ name: 'customer[shipping_address]', value: shippingContact.addressLines.join(', ') },
				{ name: 'customer[shipping_postal_code]', value: shippingContact.postalCode },
			];

			formDataArray.push(...shippingData);
		}
		formDataArray.push(
			{ name: 'customer[email]', value: (billingContact?.emailAddress ?? shippingContact?.emailAddress ?? null) },
			{ name: 'customer[billing_phone]', value: (billingContact?.phoneNumber ?? shippingContact?.phoneNumber ?? null) },
			{ name: 'customer[raw_billing]', value: JSON.stringify(billingContact) },
			{ name: 'customer[raw_shipping]', value: JSON.stringify(shippingContact) },
		);

		const checkoutSelection = [
			{ name: 'checkout_selection[payment_method]', value: payOptions.handler },
			// { name: 'checkout_selection[shipping_method]', value: 2 },
		];

		formDataArray.push(...checkoutSelection);

		// Encode to form
		const params = new URLSearchParams();
		for (const item of formDataArray) {
			params.append(item.name, item.value);
		}

		params.append('cart_source', cart_source);

		const urlEncodedData = params.toString();
		// Execute the remote action
		cart.processOrder(urlEncodedData)
			.then((payment_data) => {
				if (payment_data.errors) {
					handleSessionError(payment_data.errors.map(v => v.message ?? v).join('<br />'));
				}
				else {
					processPayment(apple_payment, payment_data);
				}
			})
			.catch((error) => {
				console.warn('Error saving order:', error);
				const message = (error instanceof XhrError ? error.responseJSON.message : (error.message ?? mpro.langvar('error_unknown')));
				handleSessionError(message);
			});
	};

	// Handle cart payment
	function handleCheckoutPayment(apple_payment) {
		saveOrderPayment()
			.then(response => response.json())
			.then((payment_data) => {

				if (payment_data.errors) {
					handleSessionError(payment_data.errors.map(v => v.message ?? v).join('<br />'));
				}
				else {
					processPayment(apple_payment, payment_data);
				}
			})
			.catch((error) => {
				console.warn('Error saving order:', error);
				handleSessionError(error.message);
			});
	}

	// Target element is a form
	if (targetIsForm) {
		$paymentForm = $trigger;
		$submitButton = $trigger.find('button[type=submit]');
		payOptions = getOptionsFromDataset($paymentForm[0], 'apple-pay', true);
	}
	// Target element is a button/link
	else {
		$submitButton = $trigger;

		// Send the whole parent form (or selected form)
		if ('applePayForm' in extraOptions) {
			// Select form by id of current form
			$paymentForm = extraOptions.applePayForm && (typeof extraOptions.applePayForm === 'string' && extraOptions.applePayForm !== '') ? $(extraOptions.applePayForm) : $trigger.closest('form');

			if ($paymentForm.length === 0) {
				console.warn('Could not find form target for \'apple-pay\' action', extraOptions.cartAddForm);
				return false;
			}

			payOptions = getOptionsFromDataset($paymentForm[0], 'apple-pay', true);

			if ($paymentForm.parsley().validate() === false) {
				return false;
			}
		}
		// Send only data provided in the link/button (item data cannot be mixed with form-data)
		else {
			isProductPayment = true;
			payOptions = getOptionsFromDataset($submitButton[0], 'apple-pay', true);
		}
	}

	// ## Main functionality below

	// Create the Apple Pay session
	const version = 3;
	mpro.addButtonLoading($submitButton);

	// @ts-ignore
	const session = new ApplePaySession(version, payOptions.paymentRequest ?? {});

	if (isProductPayment) {
		try {
			// Init a new cart with current product
			await initProductCart();
		}
		catch (error) {
			const message = (error instanceof XhrError
				? (error?.responseJSON?.message ?? mpro.langvar('error_unknown'))
				// @ts-ignore
				: (error.message ?? mpro.langvar('error_unknown')));

			handleSessionError(message);
			return false;
		}
	}

	// Merchant validation
	session.onvalidatemerchant = (event) => {

		const { validationURL } = event;
		fetch(mpro.config.payment.apple_pay.endpoints.validate_merchant, {
			method: 'POST',
			body: JSON.stringify({ validationURL }),
			headers: {
				'Content-Type': 'application/json',
			},
		})
			.then(response => response.json())
			.then((data) => {
				session.completeMerchantValidation(data);
			})
			.catch((error) => {
				console.error('Error validating merchant:', error);
				handleSessionError(error.message);
			});
	};

	if (isProductPayment) {

		// https://developer.apple.com/documentation/apple_pay_on_the_web/applepaysession/1778009-onshippingcontactselected
		session.onshippingcontactselected = (event) => {
			// https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentcontact
			const { shippingContact } = event;

			try {
				const postData = {
					'cart_source': cart_source,
					'customer': {
						'shipping_as_billing': true,
						'billing_name': `${shippingContact?.givenName} ${shippingContact?.familyName}`,
						'billing_phone': shippingContact?.phoneNumber ?? null,
						'billing_country_code': shippingContact?.countryCode ?? null,
						'billing_state': shippingContact?.administrativeArea ?? null,
						'billing_city': shippingContact?.locality ?? null,
						'billing_postal_code': shippingContact?.postalCode ?? null,
						'billing_address': Array.isArray(shippingContact?.addressLines) ? shippingContact.addressLines.join(', ') : '',
						'apple_shipping': JSON.stringify(shippingContact),
					},
				};

				cart.setUserData(postData)
				.then((response) => {

					const { error, message, data } = response;
					if (error) {
						// Show error message
						handleSessionError(message);
						return;
					}

					const updatePayload = {
						'newTotal': {
							'type': 'final',
							'label': payOptions.paymentRequest.total.label ?? data.items[0].name ?? 'Buy now',
							'amount': data.total_amount,
						},
						'newShippingMethods': $.map(data.shipping_methods, (method) => {
							return {
								'label': method.name,
								'detail': method.hint ?? '',
								'amount': method.cost,
								'identifier': method.id,
							};
						}),
					};

					session.completeShippingContactSelection(updatePayload);
				})
				.catch((error) => {
					const message = (error instanceof XhrError ? error.responseJSON.message : (error.message ?? mpro.langvar('error_unknown')));
					handleSessionError(message);
				});
			}
			catch (error) {
				// @ts-ignore
				const message = (error.message ?? mpro.langvar('error_unknown'));
				handleSessionError(message);
			}
		};

		//  https://developer.apple.com/documentation/apple_pay_on_the_web/applepaysession/1778028-onshippingmethodselected
		session.onshippingmethodselected = (event) => {
			// https://developer.apple.com/documentation/apple_pay_on_the_web/applepayshippingmethod
			const { shippingMethod } = event;

			cart.setShippingMethod({ id: shippingMethod.identifier, 'cart_source': cart_source })
				.then( (response) => {

					const { error, message, data } = response;
					if (error) {
						handleSessionError(message);
						return;
					}

					const updatePayload = {
						'newTotal': {
							'type': 'final',
							'label': payOptions.paymentRequest.total.label ?? data.items[0].name ?? 'Buy now',
							'amount': data.total_amount,
						},
					};

					session.completeShippingMethodSelection(updatePayload);
				})
				.catch((error) => {
					const message = (error instanceof XhrError ? error.responseJSON.message : (error.message ?? mpro.langvar('error_unknown')));
					handleSessionError(message);
				});
		};
	}

	// Payment authorized
	session.onpaymentauthorized = (event) => {
		const apple_payment = event.payment;
		if (isProductPayment) {
			finishProductPayment(apple_payment);
		}
		else {
			handleCheckoutPayment(apple_payment);
		}
	};

	session.oncancel = (/* event */) => {
		console.log('canceled');
		mpro.removeButtonLoading($submitButton);
	};

	// Start the Apple Pay session
	session.begin();
};

/**
 * @param {JQuery} $hiddenElements
 */
const toggleApplyPayElementsVisibility = ($hiddenElements) => {

	if ($hiddenElements.length === 0) {
		return;
	}
	const { ApplePaySession } = window;

	const isAvailable = ApplePaySession && ApplePaySession.canMakePayments();
	if (!isAvailable) {
		return;
	}

	/* const capabilities = await ApplePaySession.applePayCapabilities();
	let isActive = false;

	// Check whether the person has an active payment credential provisioned in Wallet.
	switch (capabilities.paymentCredentialStatus) {
		case 'paymentCredentialsAvailable': {
			// Display an Apple Pay button and offer Apple Pay as the primary payment option.
			isActive = true;
			break;
		}
			// case "paymentCredentialStatusUnknown":
			// // Display an Apple Pay button and offer Apple Pay as a payment option.
			// case "paymentCredentialsUnavailable":
			// // Consider displaying an Apple Pay button.
			// case "applePayUnsupported":
			// // Don't show an Apple Pay button or offer Apple Pay.
	}

	console.log(isActive);

	if (isActive === false) {
		return;
	} */

	// Display the hidden elements
	for (const element of $hiddenElements) {
		const $element = $(element);

		// Checkout form radio button
		if ($element.is('input[type=radio]')) {
			$element.parents(':hidden').show();
		}
		// Product page button
		else {
			$element.show();
		}
	}
};

// Function to check if the device is an Apple device
const looksLikeAppleDevice = function() {
	return [
		'iPad Simulator',
		'iPhone Simulator',
		'iPod Simulator',
		'iPad',
		'iPhone',
		'iPod',
	].includes(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
};

/**
 * @param {JQuery} $hiddenElements
 * @param {number} waitTimeElapsed
 */
const waitForApplePay = ($hiddenElements, waitTimeElapsed) => {

	const maxWaitTime = 10_000;
	const delay = 500;

	// There is nothing to show
	if ($hiddenElements.length === 0) {
		return;
	}

	if (looksLikeAppleDevice() === false) {
		return;
	}

	// ApplyPay JS api is available
	if (window.ApplePaySession) {
		toggleApplyPayElementsVisibility($hiddenElements);
	}
	// Wait for ApplePay JS api to load
	else if (waitTimeElapsed < maxWaitTime) {
		setTimeout(waitForApplePay, delay, $hiddenElements, waitTimeElapsed + delay);
	}
};

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {
	const waitTimeElapsed = 0;
	// Look for apple pay elements that need to be displayed
	const $hiddenElements = $container.find('[data-payment-handler="apple_pay"]');

	waitForApplePay($hiddenElements, waitTimeElapsed);
});

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
// @ts-ignore
mpro.addInitDelegate(($) => {

	const $B = mpro.get$B();

	const customButton = document.querySelector('apple-pay-button[data-apple-pay]');
	if (customButton) {
		customButton.addEventListener('click', function() {
			// $(this).trigger('click', [$.Event(event)]);

			// Create a jQuery event object and pass the native event
			const jqueryEvent = $.Event('click', { originalEvent: event });

			// Trigger the jQuery event handler with the jQuery event object
			$(this).trigger(jqueryEvent);
		});
	}

	// Handle click event for add-to-cart buttons
	$B.on('click.applePay', 'apple-pay-button[data-apple-pay], a[data-apple-pay],button[data-apple-pay],div[data-apple-pay],span[data-apple-pay],a[data-apple-pay-form],button[data-apple-pay-form],div[data-apple-pay-form],span[data-apple-pay-form]', applePayHandler);
	$B.on('submit.applePay', 'form[data-apple-pay]', applePayHandler);

	/**
	 * @this {any}
	*/
	const toggleData = function() {

		const $this = $(this);
		const $paymentForm = $this.closest('form');
		const $submitButton = $paymentForm.find('button[type=submit]');

		if ($this.data('paymentHandler') === 'apple_pay') {
			$paymentForm.attr('data-apple-pay', '');
			$paymentForm.attr('data-apple-pay-payment-request', $this.attr('data-payment-request-payload'));
			$paymentForm.attr('data-apple-pay-endpoint', $this.attr('data-payment-endpoint'));
			$submitButton.attr('data-apple-pay-form', '');
		}
		else {
			$paymentForm.removeAttr('data-apple-pay');
			$paymentForm.removeAttr('data-apple-pay-payment-request');
			$submitButton.removeAttr('data-apple-pay-endpoint');
			$submitButton.removeAttr('data-apple-pay-form');
		}
	};

	// data-section-id

	$B.on('change.applePay', 'input[type=radio][name*="checkout"][name*="[payment_method][value]"]', function() {
		toggleData.call(this);
	});
	if ($('input[type=radio][name*="checkout"][name*="[payment_method][value]"]:checked').length > 0) {
		toggleData.call($('input[type=radio][name*="checkout"][name*="[payment_method][value]"]:checked')[0]);
	}
	mpro.get$D().on('mp-section-did-reload', (e) => {
		// @ts-ignore
		if (e.originalEvent.detail.$newSection) {
			// @ts-ignore
			const $input = e.originalEvent.detail.$newSection.find('input[type=radio][name*="checkout"][name*="[payment_method][value]"]:checked');
			if ($input.length > 0) {
				toggleData.call($input[0]);
			}
		}
	});
});
